import { allPass } from 'ramda';
import { getDevice } from 'js/hooks/device/helpers';

export const filterGames = (games = {}) => {
    const device = getDevice();
    const handleOtherOs = game => game.oses.includes('other') && device.isOtherOs;
    const handleOtherBrowser = game => game.browsers.includes('other') && device.isOtherBrowser;
    const isActive = game => game.active;
    const isOsFits = game => game.oses.includes(device.os) || handleOtherOs(game);
    const isBrowserFits = game => game.browsers.includes(device.browserName) || handleOtherBrowser(game);
    const isFormFactorFits = game => game.formFactors.includes(device.formFactor);
    const isGameFits = allPass([isActive, isOsFits, isBrowserFits, isFormFactorFits]);
    const getImages = (game, isDesktop) => {
        const getImage = ({ c1x1 }) => c1x1;

        return {
            base: getImage(isDesktop ? game.imageURLs : game.mobileImageURLs),
            guest: getImage(isDesktop ? game.guestImageURLs : game.guestMobileImageURLs)
        };
    };

    return Object.values(games)
        .filter(isGameFits)
        .reduce((memo, item) => {
            const {
                active,
                gameCode,
                mobileGameCode,
                name,
                description,
                funSupport,
                jackpotCode,
                excludeFromPGG2,
                gameType,
                mobileGameType,
                seoFriendlyGameName,
                articleId,
                mobileArticleId,
                hot,
                popular,
                exclusive,
                liveLaunchAlias
            } = item;

            memo[gameCode] = {
                active,
                gameCode,
                mobileGameCode,
                images: getImages(item, device.isDesktop),
                name,
                description,
                funSupport,
                jackpotCode,
                excludeFromPGG2,
                gameType: device.isDesktop ? gameType : mobileGameType,
                seoFriendlyGameName,
                articleId: !device.isDesktop && mobileArticleId || articleId,
                isNew: item.new,
                hot,
                popular,
                exclusive,
                liveLaunchAlias
            };

            return memo;
        }, {});
};

export const parseGameFeeds = (feeds = []) =>
    feeds.map(feed => ({
        ...feed,
        categories: feed.categories.map(({ cid, name, gameCodes, roundIcon, pgg2 }) => ({
            cid,
            name,
            gameCodes,
            roundIcon,
            pgg2,
            displayName: `playtech.mobile.game-categories.${feed.name.toLowerCase()}.${name}.long`,
            displayNameShort: `playtech.mobile.game-categories.${feed.name.toLowerCase()}.${name}.short`
        }))
    }));
